// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__Kt30W","rootSmall":"AddTileButton_rootSmall__3oegR"};